import type { StorageKey } from "@exonn/storage";
import type { UserResource } from "@exonn/js-sdk";

export const getUserDataPayload = <Payload = any>(
  user: UserResource,
  storageKey: StorageKey,
): Payload | undefined => {
  const userData = (user.user_data || []).find(
    (record) =>
      record.name === storageKey.name && record.version === storageKey.version,
  );
  const payload = userData?.payload;
  if (payload) {
    return JSON.parse(payload) as Payload;
  }
  return undefined;
};
